
import { getStoreList, getInvitationList, acceptInvitation, rejectInvitation, StoreItem } from '@/api/store';
import { getStoreInfo } from '@/api/ccx'
import { Component, Mixins } from 'vue-property-decorator'
import scroll from '@/mixins/scroll'
import { chooseUserType } from '@/api/creatCompany'
import { cacheCompanyInfo } from '@/api/login'
import SelectMultiStoreRange from './selectMultiStoreRange.vue'
import { LoginReturnDataDto, setAllowsBackGesture } from '@/utils/h5ToApp';
import { Getter, Action } from 'vuex-class';
import { Debounce } from '@/core/decorator';
import { setCcxStore } from '@/views/information'
Component.registerHooks(["beforeRouteUpdate"]);

@Component({
  name: 'SelectStore',
  components: {
    SelectMultiStoreRange
  }
})
export default class SelectStore extends Mixins(scroll) {

  @Getter info!: LoginReturnDataDto
  @Getter userId!: string
  @Getter mobile!: string
  @Getter multiStoreList!: (string | number)[]
  @Getter companyId!: string
  @Action setCompanyId!: (companyId: string) => void
  @Action setCompanyName!: (companyName: string) => void
  @Action setUserId!: (userId: string) => void

  isShowBack = true

  // 多店总览范围相关
  showMultiStoreRangePopup = false
  localMultiStoreList: (string | number)[] = []

  editMultiStoreRange() {
      this.showMultiStoreRangePopup = true
  }
  
  onConfirmMultiStoreRange(selectedIds: (string | number)[]) {
      this.localMultiStoreList = selectedIds
      this.$toast.success('设置成功')
  }

  // 店铺邀请列表
  invitationList: StoreItem[] = []

  // 店铺列表
  storeList: StoreItem[] = []

  created() {
    this.initPage()
  }

  // 当重复进入选择店铺页，需初始化页面数据（PC端解绑店铺场景）
  beforeRouteUpdate(to, from, next) {
    to.query.key && this.$toast('未绑定该店铺')
    next();
    this.initPage()
  }

  initPage() {
    console.log('SelectStore created')
    this.isShowBack = !['login', 'pwdLogin', 'resetPwd', 'app', 'disBindStore', 'setPwd'].includes(this.$route.query.from as string)
    setAllowsBackGesture(this.isShowBack ? '1' : '0');
    Promise.all([this.getStoreList(), this.getInvitationList()]).then(() => {
      // 初始化多店总览范围
      if (this.multiStoreList.length > 0) {
        this.localMultiStoreList = this.storeList.filter(item => this.multiStoreList.includes(item.companyId)).map(item => item.companyId)
      } else if (this.storeList.length > 0) {
        this.localMultiStoreList = this.storeList.map(item => item.companyId)
      }
    })
  }

  async getStoreList() {
    try {
      const res = await getStoreList({
        registMobile: this.mobile
      })
      this.storeList = res.data.map(item => ({
        storeHeadPortrait: item.storeHeadPortrait,
        ...item
      }))
    } catch (err) {
      console.log('err', err)
    }
  }

  async getInvitationList() {
    try {
      const res = await getInvitationList({
        registMobile: this.mobile
      })
      this.invitationList = res.data.map(item => ({
        companyId: item.companyId,
        storeName: item.storeName,
        companyName: item.companyName,
        storeHeadPortrait: item.storeHeadPortrait
      }))
    } catch (err) {
      console.log('err', err)
    }
  }

  toCreateStore() {
    // 清除之前的表单缓存和图片缓存，确保是新的开始
    sessionStorage.removeItem('createStoreFormCache')
    sessionStorage.removeItem('editedStoreIcon')
    sessionStorage.removeItem('autoGeneratedStoreIcon')
    
    this.$router.push({
      path: '/createStore'
    })
  }
  
  onJoinStore() {
    this.$router.push('/joinStore')
  }

  // 处理邀请
  @Debounce(500)
  async acceptInvitation(item: StoreItem) {
    // this.loading = true;
    try {
      // 模拟接口调用
      const res = await acceptInvitation({
        registMobile: this.mobile,
        companyId: item.companyId
      })
      if (res.code === '000000') {
        this.$toast.clear()
        this.$toast.success(`同意了 ${item.storeName} 的邀请`);
        await this.getInvitationList();
        await this.getStoreList();
      } else {
        this.$toast.clear()
        this.$toast.fail(res.msg || '同意邀请失败');
      }
    } catch (error) {
      this.$toast.clear()
      this.$toast.fail(error.data.msg || '同意邀请失败');
    } finally {
      // this.loading = false;
    }
  }

  @Debounce(500)
  async rejectInvitation(item: StoreItem) {
    try {
      const res = await rejectInvitation({
        companyId: item.companyId,
        registMobile: this.mobile,
      })
      if (res.code === '000000') {
        this.$toast.clear()
        this.$toast.success(`拒绝了 ${item.storeName} 的邀请`);
        await this.getInvitationList();
      } else {
        this.$toast.clear()
        this.$toast.fail(res.msg || '拒绝邀请失败');
      }
    } catch (error) {
      this.$toast.clear()
      this.$toast.fail(error.data.msg || '拒绝邀请失败');
    }
  }
  
  // 进入多店总览
  toMultiStoreOverview() {
    if (this.localMultiStoreList.length < 2) {
      this.showMultiStoreRangePopup = true
      return
    }
    this.$store.commit('SET_IS_MULTI_STORE', true)
    this.$store.commit('SET_MULTI_STORE_LIST', this.localMultiStoreList)
    this.setUserId(this.$store.state.user.firstUserId)
    this.$store.dispatch('GetInfo', {
      ...this.info,
      userId: this.$store.state.user.firstUserId,
      companyId: '',
      companyName: '',
      logoUrl: '',
      storeName: '',
      storeHeadPortrait: '',
      address: '',
      addressDtl: '',
      openOnlineStore: 0,
    })
    this.$router.replace('/workbench')
    // 缓存本次进入店铺信息到服务器
    this.cacheCompanyInfoFunc({ userId: this.$store.state.user.firstUserId, companyId: 'multi_store', companyName: '多店总览' } as StoreItem)
  }

  // 选择店铺
  async onSelectStore(store: StoreItem) {
    // 存储店铺信息到 sessionStorage
    // sessionStorage.setItem('currentStore', JSON.stringify(store))
    const param = {
      oldUserId: this.$store.state.user.firstUserId, // 登录账号userId，一级用户id（魏子皓要求）
      userId: store.userId // 新创建的公司对应的userId
    }
    const res = await chooseUserType(param)
    if (res.code === '000000') {
      this.setCompanyId(store.companyId)
      this.setCompanyName(store.companyName)
      this.setUserId(store.userId)

      const logoUrl = window.location.origin + this.$downloadUrl(store.storeHeadPortrait)

      // 传给原生信息
      const obj = {
        companyInfo: store,
        userInfo: res.data,
        logoUrl,
        res: JSON.stringify(res)
      }

      // 处理多店数据
      this.$store.commit('SET_IS_MULTI_STORE', false)
      this.$store.commit('SET_MULTI_STORE_LIST', [])
      // if (this.$checkIsEmpty(store.currentVersion)) {
      //   this.$store.currentVersion = 'system'
      // }
      // 缓存信息
      this.$store.dispatch('GetInfo', { ...store, logoUrl, ...res.data })
      // 进入工作台
      this.$router.replace('/workbench')
      // 缓存本次进入店铺信息到服务器
      this.cacheCompanyInfoFunc(store)

      // 获取店铺详情数据
      getStoreInfo({ storeId: store.companyId }).then(res => {
        // 缓存常常鲜微店信息
        setCcxStore(res?.data || {})
      })
    }

    // this.$toast.loading({
    //   message: '进入中...',
    //   forbidClick: true,
    //   duration: 500
    // })

    // setTimeout(() => {
    //   this.$router.push({
    //     path: '/workbench',
    //     query: {
    //       storeId: String(store.companyId)
    //     }
    //   })
    // }, 500)
  }

  // 进入个人中心
  toPersonalCenter() {
    this.$store.commit('SET_IS_MULTI_STORE', false)
    this.$store.commit('SET_MULTI_STORE_LIST', [])
    this.$router.push('/my');
  }

  // 缓存本次进入店铺信息到服务器
  cacheCompanyInfoFunc (storeInfo: StoreItem) {
    const params = {
      userId: storeInfo.userId,
      companyId: storeInfo.companyId,
      mobile: this.mobile
    }
    cacheCompanyInfo(params)
  }
}
